import{jsx as a}from"react/jsx-runtime";import{twMerge as e}from"tailwind-merge";
/**
 * 숫자를 표시하는 뱃지 컴포넌트
 *
 * @component
 * @param {object} props
 * @param {string | number} props.text - 뱃지에 표시될 텍스트 또는 숫자, 0을 보여줄 때에는 String이어야 함
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {'primary' | 'white_primary' | 'white_gray' | 'gray'} [props.variant='primary'] - 뱃지의 스타일 변형
 * @param {boolean} [props.showZero=false] - 값이 0일 때 뱃지를 표시할지 여부
 *
 * @example
 * // 기본 사용법
 * <CountBadge text="5" />
 *
 * // 0 표시하기
 * <CountBadge text="0" showZero={true} />
 *
 * // 다른 스타일 변형 사용
 * <CountBadge text="10" variant="white_primary" />
 */const t=({text:t,className:s,variant:r="primary",showZero:n=!1})=>{var i;const m=!n&&0==t||""===t,l=Number(t)>99?"99+":t,d={baseClass:"absolute box-border flex min-h-4 w-fit min-w-4 select-none items-center justify-center rounded-full px-1 py-px text-[11px] font-normal tracking-normal leading-none",matchedVariantClass:null===(i=[{name:"primary",className:"text-w-white bg-primary"},{name:"white_primary",className:"text-primary bg-w-white"},{name:"white_gray",className:"text-w-gray-600 bg-w-white"},{name:"gray",className:"text-w-gray-600 bg-w-gray-200"}].find((a=>a.name===r)))||void 0===i?void 0:i.className,hiddenClass:m&&"hidden"};/*#__PURE__*/
return a("span",{"data-testid":"design-system-count-badge",className:e(d.baseClass,d.matchedVariantClass,d.hiddenClass,s),children:l})};export{t as CountBadge};
